import { render, staticRenderFns } from "./Notation.vue?vue&type=template&id=455954fa&scoped=true"
import script from "./Notation.vue?vue&type=script&lang=js"
export * from "./Notation.vue?vue&type=script&lang=js"
import style0 from "./Notation.vue?vue&type=style&index=0&id=455954fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455954fa",
  null
  
)

export default component.exports